import React, { useState, useCallback, useEffect } from 'react';
import { GALLERY_ITEMS } from '../../data/constants';
import './Gallery.css';

const Gallery = () => {
  const [selectedIndex, setSelectedIndex] = useState(null);
  const isOpen = selectedIndex !== null;

  const handleOpen = useCallback((index) => {
    setSelectedIndex(index);
  }, []);

  const handleClose = useCallback(() => {
    setSelectedIndex(null);
  }, []);

  const handlePrevious = useCallback((e) => {
    e.stopPropagation();
    setSelectedIndex((prev) => (prev - 1 + GALLERY_ITEMS.length) % GALLERY_ITEMS.length);
  }, []);

  const handleNext = useCallback((e) => {
    e.stopPropagation();
    setSelectedIndex((prev) => (prev + 1) % GALLERY_ITEMS.length);
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isOpen) return;
      if (e.key === 'Escape') handleClose();
      if (e.key === 'ArrowLeft') handlePrevious(e);
      if (e.key === 'ArrowRight') handleNext(e);
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, handleClose, handlePrevious, handleNext]);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  const currentItem = selectedIndex !== null ? GALLERY_ITEMS[selectedIndex] : null;

  return (
    <section className="galeria" id="galeria">
      <div className="wrap">
        <div className="sechead">
          <span className="kicker">Por dentro</span>
          <h2>Consultoria acontece dentro da empresa</h2>
          <p>
            Não é relatório enviado por e-mail. É gente sentada com o dono, no salão, no galpão, na clínica. Até o número virar decisão.
          </p>
        </div>
        <div className="ggrid">
          {GALLERY_ITEMS.map((item, index) => (
            <button
              key={item.id}
              className="gitem"
              onClick={() => handleOpen(index)}
              aria-label={`Ver foto: ${item.caption}`}
            >
              <img
                src={item.thumb}
                alt={item.alt}
                loading="lazy"
                decoding="async"
              />
              <span className="cap">{item.caption}</span>
            </button>
          ))}
        </div>
        <p className="gnote">Toque em uma foto para ampliar.</p>
      </div>

      {isOpen && (
        <div
          className="gmodal"
          role="dialog"
          aria-modal="true"
          aria-label="Galeria de fotos"
          onClick={handleClose}
        >
          <button
            className="gclose"
            onClick={handleClose}
            aria-label="Fechar galeria"
          >
            ×
          </button>
          <button
            className="gnav gprev"
            onClick={handlePrevious}
            aria-label="Foto anterior"
          >
            ‹
          </button>
          <button
            className="gnav gnext"
            onClick={handleNext}
            aria-label="Próxima foto"
          >
            ›
          </button>
          <div className="gmodal-content">
            <img
              src={currentItem.full}
              alt={currentItem.alt}
            />
            <div className="gcap">{currentItem.caption}</div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Gallery;
